import { useEffect, useRef } from 'react';
import { useSocket } from '../../contexts/socket/SocketContext';

const THROTTLE_MS = 60_000;

interface UseProjectSocketOptions {
  projectId: number | null;
  onProjectStatsUpdate: (projectId: number) => void;
}

export const useProjectSocket = ({ projectId, onProjectStatsUpdate }: UseProjectSocketOptions) => {
  const socket = useSocket();
  const lastRefreshTime = useRef<number>(0);

  useEffect(() => {
    if (!socket || !projectId) return;

    const handleProjectStatsUpdate = (data: { projectId: number; refresh: boolean }) => {
      if (data.refresh && data.projectId === projectId) {
        const now = Date.now();
        if (now - lastRefreshTime.current >= THROTTLE_MS) {
          console.log(`[ProjectSocket] Stats updated for project ${projectId}`);
          lastRefreshTime.current = now;
          onProjectStatsUpdate(projectId);
        }
      }
    };

    socket.on('project-stats-update', handleProjectStatsUpdate);

    return () => {
      socket.off('project-stats-update', handleProjectStatsUpdate);
    };
  }, [socket, projectId, onProjectStatsUpdate]);
};
